<h2 mat-dialog-title style="text-align: center">
  {{ title }}
</h2>
<mat-dialog-content class="mat-typography" style="padding-bottom: 0.5rem;">
  <h3 *ngIf="name" style="text-align: center">
    {{ name }}
  </h3>
  <div
    *ngIf="orderData"
    class="row-layout"
    style="justify-content: center; width: 100%"
  >
    <div>
      <h3 *ngIf="orderData.id">ID: {{ orderData.id }}</h3>
      <h3 *ngIf="orderData.customer_name">
        Kunde: {{ orderData.customer_name }}
      </h3>
      <h3 *ngIf="orderData.plate">Kennzeichen: {{ orderData.plate }}</h3>
    </div>
  </div>
</mat-dialog-content>
<div
  mat-dialog-actions
  class="row-layout"
  style="justify-content: space-between"
>
  <button mat-button (click)="doNotDelete()">Nein</button>
  <button mat-button style="margin-left: 1rem" (click)="doDelete()">Ja</button>
</div>
